// extracted by mini-css-extract-plugin
module.exports = {"container":"Photography-module--container--1o-J8"};